export function getCurrentUserId(): number {
  try {
    const rawUser = localStorage.getItem('authUser');
    if (!rawUser) {
      return 1;
    }

    const user = JSON.parse(rawUser) as { pkUsuario?: number; id?: number };
    return Number(user.pkUsuario ?? user.id ?? 1) || 1;
  } catch {
    return 1;
  }
}
